import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarUsuariosGrupoMensagens(api, parametros) { 
    parametros.operacao = 'buscarUsuariosGrupoMensagens';

    let retorno = {};
    await api.santriGET('/rest/mensagem', parametros, 10, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response)
    })
    .catch(erro => {
      retorno = Biblioteca.retornoRequisicao('S', erro, undefined)
    })

    return retorno;
  },

  async buscarMensagensUsuario(api, qtdLimiteMensagem) {
    let parametros = {
      operacao: 'buscarMensagensUsuario',
      qtd_limite_mensagem: qtdLimiteMensagem
    };

    let retorno = {};
    await api.santriGET('/rest/mensagem', parametros, 10, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response)
    })
    .catch(erro => {
      retorno = Biblioteca.retornoRequisicao('S', erro, undefined)
    })

    return retorno;
  },

  async pesquisarMensagens(api, parametros) {
    parametros.operacao = 'pesquisarMensagens';

    let retorno = {};
    await api.santriGET('/rest/mensagem', parametros, 10, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response)
    })
    .catch(erro => {
      retorno = Biblioteca.retornoRequisicao('S', erro, undefined)
    })

    return retorno;
  },

  async confirmarLeituraMensagem(api, parametros) { 
    parametros.operacao = 'confirmarLeituraMensagem';

    let retorno = {};
    await api.santriPOST('/rest/mensagem', parametros, 10, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response)
    })
    .catch(erro => {
      retorno = Biblioteca.retornoRequisicao('S', erro, undefined)
    })

    return retorno;
  },

  async marcarMensagemLida(api, parametros) { 
    parametros.operacao = 'marcarMensagemLida';

    let retorno = {};
    await api.santriPOST('/rest/mensagem', parametros, 10, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response)
    })
    .catch(erro => {
      retorno = Biblioteca.retornoRequisicao('S', erro, undefined)
    })

    return retorno;
  },

  async responderMensagem(api, parametros) { 
    parametros.operacao = 'responderMensagem';

    let retorno = {};
    await api.santriPOST('/rest/mensagem', parametros, 10, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response)
    })
    .catch(erro => {
      retorno = Biblioteca.retornoRequisicao('S', erro, undefined)
    })

    return retorno;
  },

  async enviarMensagem(api, parametros) { 
    parametros.operacao = 'enviarMensagem';

    let retorno = {};
    await api.santriPOST('/rest/mensagem', parametros, 10, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response)
    })
    .catch(erro => {
      retorno = Biblioteca.retornoRequisicao('S', erro, undefined)
    })

    return retorno;
  },
  async enviarMensagem2(api, parametros) { 
    parametros.operacao = 'enviarMensagem';

    let retorno = {};
    await api.santriGET('/rest/mensagem', parametros, 10, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response)
    })
    .catch(erro => {
      retorno = Biblioteca.retornoRequisicao('S', erro, undefined)
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RMensagem.js